import { effect, input, InputSignal } from '@angular/core'

export interface PurchasedMaterialFilters {
    startDate: string
    endDate: string
    category: string
    search: string
}

export function purchasedMaterialScopeKey(filters: PurchasedMaterialFilters, includeSearch: boolean): string {
    return [filters.startDate, filters.endDate, filters.category, includeSearch ? filters.search : ''].join('|')
}

/**
 * Loads a tab the first time it is shown, and again when the filters that affect it change while it is showing.
 * A filter change also clears a hidden tab so it does not keep rows from the previous query.
 */
export function bindPurchasedMaterialTab(
    filters: InputSignal<PurchasedMaterialFilters>,
    active: InputSignal<boolean>,
    scopeKey: (filters: PurchasedMaterialFilters) => string,
    clear: () => void,
    load: (filters: PurchasedMaterialFilters) => void,
) {
    let loadedKey: string | null = null
    effect(() => {
        const current = filters()
        const key = scopeKey(current)
        const isActive = active()
        if (loadedKey !== null && loadedKey !== key) {
            clear()
            loadedKey = null
        }
        if (!isActive || loadedKey === key) return
        loadedKey = key
        clear()
        load(current)
    })
}
